import { optimizeCaller } from './util/util';
import EventHandler from './_dependencyvendor/event-handler';

const initializeCheck = el => {
  return el.getAttribute('data-function-initialized') !== 'initialized';
};
const setInitialize = el => {
  return el.setAttribute('data-function-initialized', 'initialized');
};

const scrollActions = () => {
  const actions = {};
  return {
    run: () => {
      for (const p in actions) {
        if (actions.hasOwnProperty(p)) {
          actions[p]();
        }
      }
    },

    add: (key, func) => {
      if (!actions[key]) {
        actions[key] = func;
      }
    },
    remove: key => {
      if (actions[key]) {
        delete actions[key];
      }
    },
  };
};

const actions = scrollActions();

const stickyHeader = () => {
  const pageHeaderExist = document.querySelector('.ly-header');
  const pageContentBox = document.querySelector('.ly-content');
  const stickyExist = !!document.querySelector('.ly-page-sticky');
  if (pageHeaderExist && stickyExist) {
    const headerTop = document.querySelector('.ly-header');
    const stickyGnb = document.querySelector('.header-clone__gnb');
    const isShare = document.querySelector('.header-share-button');

    actions.add('stickyHeader', () => {
      // Scrolling down
      if (window.pageYOffset > 56) {
        headerTop.classList.remove('header-slide__down');
        headerTop.classList.add('header-slide__up');
        stickyGnb && stickyGnb.classList.add('is-active');
        isShare && isShare.classList.add('is-active');
        // Scrolling up
      } else {
        headerTop.classList.remove('header-slide__up');
        stickyGnb && stickyGnb.classList.remove('is-active');
        isShare && isShare.classList.remove('is-active');
        headerTop.classList.add('header-slide__down');
      }
    });
  } else {
    if (!pageHeaderExist && pageContentBox) pageContentBox.style.paddingTop = 0;
  }
};

const formInteraction = () => {
  const forms = document.querySelectorAll('.c-form__input');
  forms.forEach(form => {
    if (initializeCheck(form)) {
      setInitialize(form);
      const input = form.querySelector('input');
      let inputValue = input.value;

      if (inputValue.length > 0) {
        form.classList.add('has-value');
      } else {
        form.classList.remove('has-value');
      }

      EventHandler.on(input, 'focusout.form-hasvalue', () => {
        inputValue = input.value;
        if (inputValue.length > 0) {
          form.classList.add('has-value');
        } else {
          form.classList.remove('has-value');
        }
      });
    }
  });
};

const searchBoxAction = () => {
  const searchInputs = document.querySelectorAll('.c-form--search');

  if (searchInputs.length > 0) {
    searchInputs.forEach(search => {
      if (initializeCheck(search)) {
        setInitialize(search);
        const inputTarget = search.querySelector('.c-input');
        // const resetBtn = inputTarget.nextElementSibling;
        const resetBtn = inputTarget.parentNode.querySelector('.c-button--reset');

        EventHandler.off(inputTarget, 'keyup');
        EventHandler.on(inputTarget, 'keyup', e => {
          if (e.currentTarget.value !== '') {
            if (!resetBtn.classList.contains('is-active')) {
              resetBtn.classList.add('is-active');
              EventHandler.one(resetBtn, 'click', () => {
                inputTarget.value = '';
                resetBtn.classList.remove('is-active');
                inputTarget.focus();
              });
            }
          } else {
            resetBtn.classList.remove('is-active');
            EventHandler.off(resetBtn, 'click');
          }
        });
      }
    });
  }
};

/**
 * 스크롤 영역 변경
 */
const scrollChange = () => {
  const changeScrollBoxs = document.querySelectorAll('.c-filter--accordion');
  if (changeScrollBoxs.length) {
    changeScrollBoxs.forEach(box => {
      if (initializeCheck(box)) {
        setInitialize(box);
        const updateSize = (target, inner, expandBtn) => {
          // 예외처리 하지 않으면 펼침버튼 눌렀을 때 옵저버에 등록 된 함수가 실행되어 버튼이 사라진다.
          if (!target.classList.contains('is-expanded')) {
            if (inner.scrollWidth - target.offsetWidth > 20) {
              expandBtn.style.display = 'block';
            } else {
              expandBtn.style.display = 'none';
            }
          }
        };
        box.setAttribute('data-sc-change-initialize', 'true');
        const expandBtn = box.querySelector('.c-filter--accordion__button');
        const inner = box.querySelector('.c-filter__inner');
        EventHandler.on(expandBtn, 'click', e => {
          e.preventDefault();
          e.target.parentNode.classList.toggle('is-expanded');
          if (e.target.parentNode.classList.contains('is-expanded')) {
            e.target.setAttribute('aria-expanded', 'true');
            expandBtn.innerHTML = '<span class="c-hidden">접기</span>';
          } else {
            e.target.setAttribute('aria-expanded', 'false');
            expandBtn.innerHTML = '<span class="c-hidden">펼치기</span>';
          }
        });
        const ro = new ResizeObserver(entries => {
          entries.forEach(entry => {
            const { target } = entry;
            updateSize(target, inner, expandBtn);
          });
        });
        ro.observe(box);
      }
    });
  }
};

/**
 * 인풋 카운터
 */
// 카운터 작동
const counter = () => {
  const counters = document.querySelectorAll('.c-counter');
  if (counters.length) {
    [].forEach.call(counters, el => {
      const btnPlus = el.querySelector('.plus');
      const btnMinus = el.querySelector('.minus');
      const valueBox = el.querySelector('input');
      const min = parseInt(valueBox.getAttribute('min') || -1);
      const max = parseInt(valueBox.getAttribute('max') || -1);
      const step = parseInt(valueBox.getAttribute('step') || 1);
      let initialValue = parseInt(valueBox.value) || min;

      EventHandler.off(btnPlus, 'click');
      EventHandler.off(btnMinus, 'click');

      const updateValue = () => {
        valueBox.value = initialValue;
      };

      valueBox.change = () => {
        const rValue = parseInt(valueBox.value);
        initialValue = rValue >= max ? max : rValue <= min ? min : rValue;
        updateValue();
      };

      EventHandler.on(btnPlus, 'click', () => {
        if (initialValue + step <= max) {
          initialValue += step;
          updateValue();
        }
      });

      EventHandler.on(btnMinus, 'click', () => {
        if (initialValue - step >= min) {
          initialValue -= step;
          updateValue();
        }
      });

      updateValue();
    });
  }
};

/*
 * top banner 올리기
 */
const topBannerInit = () => {
  const banner = document.querySelector('#top_banner');
  let swiperTopBanner = null;
  if (banner) {
    swiperTopBanner = new Swiper(banner.querySelector('.top-banner-swiper'), {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 30,
      observer: true,
      observeParents: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
    });
  }
  const bannerClose = document.querySelector('.top-banner--close');
  EventHandler.one(bannerClose, 'click', e => {
    e.preventDefault();
    banner.style.height = `${banner.offsetHeight}px`;
    // eslint-disable-next-line no-unused-vars
    const reflow = banner.offsetHeight;
    banner.style.height = ``;
    EventHandler.one(banner, 'transitionend', () => {
      swiperTopBanner.destroy();
      swiperTopBanner = null;
      banner.parentNode.removeChild(banner);
    });
    banner.classList.remove('is-active');
  });
};

/**
 * 버튼이랑 연결된 바텀시트 처리
 */
const floatingWithBottomSheet = () => {
  const buttons = document.querySelectorAll('[data-floating-bs-trigger]');
  const bsDic = new Map();
  if (buttons.length > 0) {
    buttons.forEach(button => {
      EventHandler.on(button, 'click', e => {
        const me = e.currentTarget;
        const isActive = me.getAttribute('data-deactive');
        if (isActive === 'true') return;

        me.setAttribute('data-deactive', 'true');
        e.preventDefault();
        const bsName = e.currentTarget.getAttribute('data-floating-bs-trigger');
        const bsTarget = document.querySelector(bsName);
        if (!bsTarget) {
          console.warn(`[ ${bsName} ] 으로 선언된 BottomSheet를 찾지 못했습니다.`);
        }

        me.classList.add('is-deactive');
        setTimeout(() => {
          if (!bsDic.get(bsTarget)) {
            const bs = new KTM.Dialog(bsTarget);
            bsDic.set(bsTarget, bs);
          }
          bsDic.get(bsTarget).open();
          EventHandler.one(bsTarget, 'ui.dialog.opened', () => {
            me.classList.remove('is-deactive');
            me.classList.remove('is-active');
          });
          EventHandler.one(bsTarget, 'ui.dialog.closed', () => {
            me.classList.add('is-active');
            me.removeAttribute('data-deactive');
          });
        }, 250);
      });
    });
  }
};

/**
 * 요금제 비교함 뱃지 아이콘
 */
const badgeOpenner = () => {
  const badge = document.querySelector('.c-side-badge');
  if (badge) {
    let lastScrollTop = 0;
    actions.add('badgeOpenner', () => {
      const st = window.pageYOffset;
      if (st < lastScrollTop) {
        badge.classList.add('is-active');
      } else {
        badge.classList.remove('is-active');
      }
      lastScrollTop = st <= 0 ? 0 : st;
    });
    setTimeout(() => {
      badge.classList.add('is-active');
    }, 700);
  }
};

/**
 * 모달내 요금제 비교함 뱃지 아이콘
 */
const modalBadgeOpenner = () => {
  const modalBadge = document.querySelector('.c-modal .c-side-badge');
  if (modalBadge) {
    const modalBody = document.querySelector('.c-modal__body');
    let timer;
    modalBody.addEventListener('scroll', () => {
      let lastScrollTop = 0;
      const st = window.pageYOffset;
      if (st < lastScrollTop) {
        modalBadge.classList.remove('is-active');
      } else {
        modalBadge.classList.add('is-active');
      }
      lastScrollTop = st <= 0 ? 0 : st;
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        modalBadge.classList.remove('is-active');
        console.log('AAAAAAAAAAA');
      }, 700);
    });
  }
};

// 셀렉트 폼에서 값 선택 후 레이블 및 값 유지 처리
const selectInteraction = () => {
  const selects = document.querySelectorAll('.c-form__select');
  if (selects.length > 0) {
    selects.forEach(eachSelect => {
      if (initializeCheck(eachSelect)) {
        setInitialize(eachSelect);
        const select = eachSelect.querySelector('select');
        let selectValue = select.value;

        if (selectValue.length > 0) {
          eachSelect.classList.add('has-value');
        } else {
          eachSelect.classList.remove('has-value');
        }

        EventHandler.on(eachSelect, 'focusout.select', () => {
          selectValue = select.value;
          if (selectValue.length > 0) {
            eachSelect.classList.add('has-value');
          } else {
            eachSelect.classList.remove('has-value');
          }
        });
      }
    });
  }
};

/**
 * 인풋 그룹 포커스 활설화 시 아웃라인 처리
 */
const inputGroupInteraction = () => {
  const forms = document.querySelectorAll('.c-form__input-group input');
  [].forEach.call(forms, input => {
    if (initializeCheck(input)) {
      setInitialize(input);
      EventHandler.on(input, 'focusin.outline', () => {
        input.parentElement.parentElement.classList.add('is-focused');
      });
      EventHandler.on(input, 'focusout.outline', () => {
        input.parentElement.parentElement.classList.remove('is-focused');
      });
    }
  });
};

/**
 * 전체메뉴
 */
const allMenu = () => {
  const allMenuContainer = document.querySelector('.nav-wrap');
  const navDim = document.querySelector('.nav-dim');
  const headerOpenner = document.querySelector('.ly-header__gnb');
  const headerOpenner2 = document.querySelector('.header-clone__gnb');

  const allMenuEl = document.querySelector('.nav-wrap__menu-sub.c-accordion');
  const allMenu = window.KTM.Accordion.getInstance(allMenuEl);

  if (allMenu) {
    const menuDepth = document.querySelectorAll('.depth1 a');
    const subDepth = document.querySelectorAll('.depth2');
    const allMenuCloseButoton = document.querySelector('.nav-wrap__link--close');
    let saveBodyScrollPos = 0;

    const openMenu = e => {
      e.preventDefault();
      allMenuContainer.style.display = 'block';
      navDim.style.display = 'block';
      // eslint-disable-next-line no-unused-vars
      const reflow = navDim.offsetHeight;
      allMenuContainer.classList.add('is-active');
      navDim.classList.add('is-active');
      saveBodyScrollPos = window.scrollY;
      document.body.style.overflow = 'hidden';
      activeCurrentPage();
    };

    const closeMenu = e => {
      e.preventDefault();
      if (allMenuContainer.classList.contains('is-active')) {
        allMenuContainer.classList.remove('is-active');
        navDim.classList.remove('is-active');
        document.body.style.overflow = 'auto';
        window.scrollY = saveBodyScrollPos;
        EventHandler.one(navDim, 'transitionend', () => {
          navDim.style.display = 'none';
          allMenuContainer.style.display = 'none';
          allMenu.closeAll();
        });
      }
    };

    const activeMenu = el => {
      // 서브메뉴 변경 시 아코디언 모두 닫기
      allMenu.closeAll();
      menuDepth.forEach(el => el.classList.remove('is-active'));
      el.classList.add('is-active');
    };

    const show = el => {
      el.style.display = 'block';
    };

    const hide = () => {
      subDepth.forEach(el => (el.style.display = 'none'));
    };

    const activeCurrentPage = () => {
      const activeMainDepth = id => {
        const mainMenu = document.querySelector(`a[href="#${id}"]`);
        if (mainMenu) {
          mainMenu.click();
        }
      };
      const wrapper = document.querySelector('.nav-wrap__menu');
      const codeInput = document.querySelector('#gnbMCode');
      if (!codeInput) return;
      const curentPageCode = codeInput.getAttribute('value');
      if (!curentPageCode) return;

      const pageCodes = wrapper.querySelectorAll('[data-code]');

      pageCodes.forEach(link => {
        const linkCode = link.getAttribute('data-code');
        if (linkCode) {
          if (linkCode === curentPageCode) {
            const parentMenu = link.closest('.nav-wrap__menu-item.depth2');
            const hasParentAccordion = link.closest('.nav-wrap__menu-item--ty1');
            const accordion = hasParentAccordion.querySelector('[data-acc-header]');
            if (parentMenu) {
              const containerID = parentMenu.getAttribute('id');
              activeMainDepth(containerID);
            }

            if (accordion) {
              // hash change 문제 발생 시 아래 코드로 대체하여 해결 가능
              accordion.click(); // 클릭 이벤트 발생시켜 아코디언 오픈
              // allMenu.open(accordion); // 아코디언 API 를 통해 아코디언 오픈
            } else {
            }
            link.classList.add('is-active');
          }
        }
      });
    };

    EventHandler.on(headerOpenner, 'click', openMenu);
    EventHandler.on(headerOpenner2, 'click', openMenu);
    EventHandler.on(allMenuCloseButoton, 'click', closeMenu);

    menuDepth.forEach(el => {
      EventHandler.on(el, 'click', e => {
        e.preventDefault();
        const href = e.currentTarget.getAttribute('href');
        const target = document.querySelector(href);
        hide();
        show(target);
        activeMenu(e.currentTarget);
      });
    });
  }
};

/**
 * 통합검색 스크롤 시 검색창 보더 생성
 */
const totalSearchAddBorder = () => {
  const totalSearch = document.querySelector('#total_search_dialog');
  if (totalSearch) {
    const modalBody = totalSearch.querySelector('.c-modal__body');
    const modalSearch = totalSearch.querySelector('.c-modal__search');

    actions.add('totalSearchAddBorder', () => {
      if (modalBody.scrollTop > 0) {
        if (!modalSearch.classList.contains('u-bb-gray-3')) {
          modalSearch.classList.add('u-bb-gray-3');
        }
      } else {
        modalSearch.classList.remove('u-bb-gray-3');
      }
    });
  }
};

/**
 * scroll move
 */
const gotoScrollY = () => {
  const scTopTrigger = document.querySelectorAll('[data-scroll-top]');
  scTopTrigger.forEach(target => {
    if (initializeCheck(target)) {
      setInitialize(target);
      EventHandler.off('click');
      EventHandler.on(target, 'click', e => {
        const scTargetString = target.getAttribute('data-scroll-top');
        const scTargetStringArr = scTargetString.split('|');
        const scTargetName = scTargetStringArr[0];
        const diffNum = scTargetStringArr[1] || 0;
        const scTarget = document.querySelector(scTargetName);
        if (scTarget) {
          e.preventDefault();
          scrollTo({
            top: scTarget.getBoundingClientRect().top + (window.pageYOffset - parseInt(diffNum)),
            behavior: 'smooth',
          });
        }
      });
    }
  });
};

/**
 * main gnb
 */
const mainGnb = () => {
  const gnbWrap = document.querySelector('.main-gnb');
  if (gnbWrap) {
    if (gnbWrap.classList.contains('main')) return;
    const mainDepthMenu = document.querySelectorAll('.nav-depth--one li');
    const mainDepthContainer = document.querySelector('.nav-depth--one');
    const subDepthMenuLinks = document.querySelectorAll('.nav-depth--two li');
    const threeDepthMenu = document.querySelectorAll('.nav-depth--three');

    const openSubDepth = (target, parent = null) => {
      try {
        const child = document.querySelector(target);
        if (child) {
          const sb = child.parentElement.children;
          [...sb].forEach(el => {
            el.scrollLeft = 0;
            el.classList.remove('is-active');
          });
          child.classList.add('is-active');
        } else {
          if (parent) {
            parent.forEach(el => {
              el.scrollLeft = 0;
              el.classList.remove('is-active');
            });
          }
        }
      } catch (e) {
        parent.forEach(el => {
          el.scrollLeft = 0;
          el.classList.remove('is-active');
        });
      }
    };

    const activeDepth1 = target => {
      mainDepthMenu.forEach(el => {
        el.querySelector('a').classList.remove('is-active');
      });
      target.classList.add('is-active');
    };

    const activeDepth2 = target => {
      subDepthMenuLinks.forEach(el => {
        el.querySelector('a').classList.remove('is-active');
      });
      target.classList.add('is-active');
    };

    EventHandler.on(gnbWrap, 'click', e => {
      const target = e.target;
      const depth1Target = target.closest('.nav-depth1');
      const depth2Target = target.closest('.nav-depth2');
      if (depth1Target) {
        const me = depth1Target.querySelector('a');
        if (me.getAttribute('href').indexOf('#') > -1) {
          e.preventDefault();
        }
        // 메뉴 활성화 시키고 하위메뉴 노출
        activeDepth1(me);
        openSubDepth(me.getAttribute('href'));
        openSubDepth(null, threeDepthMenu);
      } else if (depth2Target) {
        const me = depth2Target.querySelector('a');
        if (me.getAttribute('href').indexOf('#') > -1) {
          e.preventDefault();
          // 메뉴 활성화 시키고 하위메뉴 노출
          activeDepth2(me);
          // 하위메뉴 노출
          openSubDepth(me.getAttribute('href'), threeDepthMenu);
        }
      }
    });

    const active = () => {
      const location = window.location;
      const allLinks = document.querySelectorAll('.main-gnb a');
      const currentPathArr = location.pathname.split('/');
      const currentPathName = currentPathArr[currentPathArr.length - 1];
      allLinks.forEach(link => {
        const linkString = link.getAttribute('href');
        if (linkString.indexOf(currentPathName) > -1) {
          findParent(link);
        }
      });
    };

    const activeParent = el => {
      if (el) {
        const rootID = el.getAttribute('id');
        const rootEl = document.querySelector(`[href="#${rootID}"]`);
        if (rootEl) {
          scrollX(rootEl, mainDepthContainer);
          rootEl.classList.add('is-active');
        }
        el.classList.add('is-active');
      }
    };

    const scrollX = (el, container) => {
      const myRect = el.getBoundingClientRect();
      const diff = myRect.left + myRect.width - gnbWrap.offsetWidth;
      if (diff > 0) {
        container.scrollTo({
          left: diff + 10,
          behavior: 'smooth',
        });
      }
    };

    const findParent = link => {
      const depth3 = link.closest('.nav-depth--three');
      const depth2 = link.closest('.nav-depth--two');
      const depth1 = link.closest('.nav-depth--one');
      // 현재 페이지가 3뎁스 링크에 해당하는 페이지
      if (depth3) {
        // 나에게 직접(3뎁스) active 클래스 부여하여 active 상태 처리
        link.classList.add('is-active');
        // 나의 상위 부모를 찾아서 부모에게도 active 처리
        const parentId = depth3.getAttribute('id');
        const parentEl = document.querySelector(`#${parentId}`);
        parentEl.classList.add('is-active');
        const twoDepthContainer = document.querySelector('.nav-container-two');
        const twoDepthEl = twoDepthContainer.querySelector(`[href="#${parentId}"]`);
        const twoDepthParent = twoDepthEl.closest('.nav-depth--two');
        if (twoDepthEl) twoDepthEl.classList.add('is-active');
        // 상위 메뉴를 찾아 활성화 시킨다.
        activeParent(twoDepthParent);

        scrollX(twoDepthEl, twoDepthParent);
        // 3뎁스 메뉴 스크롤
        scrollX(link, parentEl);
      } else if (depth2) {
        // 현재 페이지가 2뎁스 링크에 해당하는 페이지
        link.classList.add('is-active');
        const twoDepthParent = link.closest('.nav-depth--two');
        // 상위 메뉴를 찾아 활성화 시킨다.
        activeParent(twoDepthParent);
        scrollX(link, twoDepthParent);
      } else if (depth1) {
        //
      }
    };

    active();
  }
};

/**
 * 메인 faq 아이콘
 */
const fabAction = () => {
  const fab = document.querySelector('.c-fab');
  const fabOpen = document.querySelector('.c-fab__open');
  const fabDim = document.querySelector('.fab-dim');
  let checkTime = null;
  if (!!fab) {
    EventHandler.on(fabDim, 'touchstart', e => {
      e.preventDefault();
    });
    actions.add('fabAction', () => {
      if (checkTime) {
        clearTimeout(checkTime);
        checkTime = null;
      }
      if (fab.classList.contains('is-active')) {
        fab.style.display = '';
        fab.classList.remove('is-active');
      }

      checkTime = setTimeout(() => {
        if (!fab.classList.contains('is-active')) {
          fab.style.display = 'block';
          // eslint-disable-next-line no-unused-vars
          const reflow = fab.offsetHeight;
          fab.classList.add('is-active');
        }
      }, 300);
    });

    fabOpen.addEventListener('click', () => {
      fabOpen.checked ? (fabDim.style.display = 'block') : (fabDim.style.display = 'none');
    });
  }
};

/**
 * 아코디언 열렸을 때 상위 배너 아웃라인 삭제
 * @param {*} accordion
 */
const accordState = accordion => {
  const accEl = document.querySelector('.with-expand-flag');
  if (!!accEl) {
    const expandFlag = document.querySelector('.expand-flag');
    // 열릴 때
    accEl.addEventListener(KTM.Accordion.EVENT.OPEN, () => {
      expandFlag.classList.add('is-expanded');
    });
    // 닫힐 때
    accEl.addEventListener(KTM.Accordion.EVENT.CLOSE, () => {
      expandFlag.classList.remove('is-expanded');
    });
  }
};

const floatingBottomSheetAction = () => {
  const bottomSheet = document.querySelector('.c-button-wrap--b-floating');
  if (bottomSheet) {
    actions.add('floatingBottomSheetAction', () => {
      const scTop = window.scrollTop || window.pageYOffset;
      if (scTop > 150) {
        // 한번만 등장하면 해당 루틴은 종료되니 등장시키고 등록 된 스크롤 핸들러 삭제
        bottomSheet.classList.add('is-active');
        actions.remove('floatingBottomSheetAction');
      }
    });
  }
};

const activePosForTabHeader = el => {
  const activeElement = typeof el === 'string' ? document.querySelector(el) : el;
  if (!activeElement) return;
  const viewport = activeElement.parentNode;
  // 스크롤 영역이 있어야 실행한다.
  if (viewport.offsetWidth < viewport.scrollWidth - 40) {
    const activeElementRect = activeElement.getBoundingClientRect();
    viewport.scrollTo({
      // 죠금 여유롭게 10px
      left: activeElementRect.left + viewport.scrollLeft - 40,
      behavior: 'smooth',
    });
  }
};

const tabHeaderAutoScroller = () => {
  const tabScrollHeaders = document.querySelectorAll('[data-active-scroll]');
  if (tabScrollHeaders.length > 0) {
    tabScrollHeaders.forEach(header => {
      if (initializeCheck(header)) {
        setInitialize(header);
        if (header.classList.contains('is-active')) {
          activePosForTabHeader(header);
        }
        EventHandler.on(header, 'click.scroll-header', event => {
          activePosForTabHeader(header);
        });
      }
    });
  }
};

const fakeDateInput = () => {
  const dateInputs = document.querySelectorAll('.date-input');
  if (dateInputs.length > 0) {
    dateInputs.forEach(el => {
      if (initializeCheck(el)) {
        setInitialize(el);
        const wrap = el.closest('.c-form__input');
        const fakeInput = document.createElement('input');
        fakeInput.type = 'date';
        fakeInput.className = 'c-hidden';
        el.parentNode.insertBefore(fakeInput, el.nextSibling);
        EventHandler.off(fakeInput, 'change.fake');
        EventHandler.on(fakeInput, 'change.fake', e => {
          el.value = fakeInput.value;
          if (wrap) {
            if (el.value.length > 0) {
              wrap.classList.add('has-value');
            } else {
              if (wrap.classList.contains('has-value')) {
                wrap.classList.remove('has-value');
              }
            }
          }
          EventHandler.trigger(el, 'change');
        });

        EventHandler.off(el, 'click.fake');
        EventHandler.on(el, 'click.fake', e => {
          e.preventDefault();
          fakeInput.focus();
          fakeInput.click();
        });
      }
    });
  }
};

const tabChangeToScroll = () => {
  const elements = document.querySelectorAll('[data-changed-scroll]');
  elements.forEach(el => {
    if (initializeCheck(el)) {
      setInitialize(el);
      EventHandler.on(el, 'ui.tab.change', event => {
        let diffSpacing = 0;
        const header = document.querySelector('.ly-page-sticky');
        if (header) {
          diffSpacing += header.offsetHeight;
        }
        const tablist = event.current.header.closest('[role="tablist"]');
        if (tablist) {
          diffSpacing += tablist.offsetHeight;
        }
        const currentContentRect = event.current.content.getBoundingClientRect();
        const resultY = currentContentRect.top + window.pageYOffset - diffSpacing;

        if (diffSpacing < window.pageYOffset) {
          window.scrollTo({
            top: resultY,
          });
        }
      });
    }
  });
};

// 이곳에서....
const initFunc = () => {
  // 헤더 고정
  stickyHeader();

  // 플로팅 버튼으로 바텀시트 노출
  floatingWithBottomSheet();

  // 스크롤 업/다운에 따라 뱃지 열림/닫힘
  badgeOpenner();

  // 모달내에 뱃지 열림/닫힘
  modalBadgeOpenner();

  // 전체메뉴 처리
  allMenu();

  // 통합검색 스크롤 시 보더생성
  totalSearchAddBorder();

  // mainGnb
  mainGnb();

  // topbanner init
  topBannerInit();

  // fab action
  fabAction();

  // accordion 열림 상태 연동
  accordState();

  // 바텀시트 스크롤 시 등장
  floatingBottomSheetAction();
};

/**
 * initialize 함수를 통해서 재초기화 필요가 있는 함수들
 * 이 함수에 추가되는 함수들은 이벤트리스너 중복으로 등록되는 사항에 주의
 */
const initialize = () => {
  // 검색 영역 작동
  searchBoxAction();
  // gotoScrollY
  gotoScrollY();
  // 인풋 포커스 활성화 시 레이블 애니메이션 처리
  formInteraction();
  // 셀렉트 폼에서 값 선택 후 레이블 및 값 유지 처리
  selectInteraction();
  // tabScroller
  tabHeaderAutoScroller();
  // fakeDateInput
  fakeDateInput();
  // 인풋 그룹 포커스 활설화 시 아웃라인 처리
  inputGroupInteraction();
  // 필터 영역에 스크롤 영역 변경
  scrollChange();
  // 탭 변경 시 스크롤 처리
  tabChangeToScroll();
  // counter
  counter();
};

const commonFunc = {
  initFunc,
  initialize,
  activePosForTabHeader,
};

window.addEventListener(
  'scroll',
  optimizeCaller(e => {
    actions.run();
  }),
);

export default commonFunc;
